const fmt = require("indian-number-format");

export default function TotalCard({ interestamount, depositinterestamount }) {
  /** ------------------ CARD STYLE ------------------ **/
  const cardStyle = {
    minWidth: "120px",
    padding: "6px 12px",
    borderRadius: "8px",
    background: "var(--background)",
    border: "2px solid var(--hover)",
    color: "var(--text)",
    display: "flex",
    flexDirection: "column",
  };

  const labelStyle = {
    fontSize: "0.7rem",
    opacity: 0.7,
    fontWeight: 500,
  };

  const valueStyle = {
    fontSize: "1rem",
    fontWeight: 700,
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "16px",
        flexWrap: "wrap",
        padding: "10px 20px",
        background: "var(--background)",
        color: "var(--text)",
        borderBottom: "1px solid var(--hover)",
      }}
    >
      <div style={cardStyle}>
        <span style={labelStyle}>DEPOSIT INTEREST AMOUNT</span>
        <span
          style={{
            ...valueStyle,
            color: "var(--buy)",
          }}
        >
          {fmt.format(parseFloat(depositinterestamount).toFixed(0))}
        </span>
      </div>
      <div style={cardStyle}>
        <span style={labelStyle}>INTEREST AMOUNT</span>
        <span
          style={{
            ...valueStyle,
            color: "var(--sell)",
          }}
        >
          {fmt.format(parseFloat(interestamount).toFixed(0))}
        </span>
      </div>
    </div>
  );
}
